import { miner } from '@cbre/digger';

const usageGeographyDataset = {
  global: 'lig_geography.global_region_desc',
  division: 'lig_geography.division_desc',
  market: 'lig_geography.market_desc',
  local: 'lig_geography.local_market_area_desc',
  submarket: 'lig_geography.submarket_desc',
  district: 'lig_geography.district_desc',
  neighborhood: 'lig_geography.neighborhood_desc',
  region: 'lig_geography.region_desc',
};

export interface WithGeographyDef {
  getGeography(): { [key: string]: any };
}

export const withGeography = (): WithGeographyDef => {
  function getGeography() {
    return miner(this, usageGeographyDataset);
  }
  return { getGeography };
};
